export default {
  methods: {
    isNumber(evt) {
      evt = evt || window.event

      const charCode = evt.which ? evt.which : evt.keyCode

      if (
        (charCode < 1632 || charCode > 1641) && // To allow arabic numbers
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
